import React from 'react';
import MultiFeatureIntegrationModal from '../../admin/integration/MultiFeatureIntegrationModal';
import useIntegrationMap from '../../admin/useIntegrationMap';
import { useAppDispatch } from '../../app/redux/useAppSelector';
import type { ButtonProps } from '../../components/Button';
import Button from '../../components/Button';
import useIsLayoutSize from '../../post/utils/useIsLayoutSize';
import { LayoutSize } from '../../post/utils/useLayoutSize';
import { UIActions } from '../../ui/uiSlice';

interface ManageIntegrationButtonProps {
  platform: string;
  variant?: 'link' | 'secondary';
  size?: ButtonProps['size'];
}

const ManageIntegrationButton = ({
  platform,
  variant = 'link',
  size,
}: ManageIntegrationButtonProps) => {
  const dispatch = useAppDispatch();
  const [integrationMap] = useIntegrationMap();
  const integration = integrationMap[platform];
  const isMobile = useIsLayoutSize(LayoutSize.mobile);

  if (isMobile) {
    return null;
  }

  return (
    <Button
      variant={variant}
      size={size}
      onClick={() => {
        if (integration) {
          dispatch(
            UIActions.openModal(MultiFeatureIntegrationModal, {
              integration,
            }),
          );
        }
        dispatch(UIActions.clearToasts());
      }}
    >
      <strong>Manage integration</strong>
    </Button>
  );
};

export default ManageIntegrationButton;
